import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "./Login/login";
import UploadPage from "./Uploads-images/uploadPage";
import HojePage from "./Prato-do-Dia/hojePage";

const AUTH_KEY = "pd_auth_v1";
function ProtectedRoute({ children }) {
  const isAuth = !!localStorage.getItem(AUTH_KEY);
  return isAuth ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/uploads-images"
          element={
            <ProtectedRoute>
              <UploadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/hoje"
          element={
            <ProtectedRoute>
              <HojePage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}
